import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";
import Notification from "../../components/Notification";
import AppContext from "../../context/AppContext";
import { AuthContext } from "../../context/AuthContext";
import useSearchParams from "../../util/useSearchParams";


function ProcessLogin() {
    const [
        [token]
    ] = useSearchParams({ token: null });
    const {
        setWelcomeShown
    } = useContext(AppContext);

    const navigate = useNavigate();
    const auth = useContext(AuthContext);
    const [error, setError] = useState();
    const [callingLogIn, setCallingLogIn] = useState();
    const [calledLogIn, setCalledLogIn] = useState();

    useEffect(() => {
        if (auth?.user) {
            setWelcomeShown(true);
        }

        if (!token) {
            setError(new Error("Login token is missing."));
        } else if (calledLogIn && auth?.user) {
            navigate("/", { replace: true });
        } else if(!callingLogIn){
            setCallingLogIn(true);
            auth.loginWithToken({ token }).then(
                () => setCalledLogIn(true)
            ).catch(setError);
        }
    }, [
        navigate,
        token,
        auth,
        callingLogIn,
        calledLogIn,
    ]);

    return error ? (
        <Notification error={error} />
    ) : (
        <Loader fullscreen />
    );
}


export default ProcessLogin;